import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
`;
export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TagCard = styled.div`
  width: fit-content;
  padding: 5px 20px;
  border-radius: 10px;
  color: ${({ theme }) => theme.neutral.white};
  background: linear-gradient(
    263.47deg,
    rgb(46, 46, 46) 34.72%,
    rgb(255, 0, 130) 82.21%
  );
  font-weight: 600;
  margin: 0 5px;
`;

export const ModalContainer = styled.div`
  width: 50%;
  height: 50%;
  max-width: 408px;
  max-height: 300px;
  background-color: ${({ theme }) => theme.neutral.white};
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  height: 3rem;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  position: relative;
  label {
    padding: 10px;
    font-size: 1rem;
  }
  button {
    position: absolute;
    right: 0;
  }
`;

export const ModalContent = styled.div`
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalFooter = styled.div`
  position: absolute;
  bottom: 0;
  height: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

export const CancelButton = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  max-width: 90px;
  margin-right: 10px;
  height: 30px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const UpdateButton = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  max-width: 90px;
  margin-right: 10px;
  height: 30px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};
